const SESSION_NAME = 'react-user';
export {SESSION_NAME};
